const t = {
  // ─── Navigation ───
  nav: {
    services: { en: "Services", de: "Leistungen" },
    calculator: { en: "Calculator", de: "Rechner" },
    objekte: { en: "Exposés", de: "Objekte" },
    projects: { en: "Projects", de: "Projekte" },
    financing: { en: "Financing", de: "Finanzierung" },
    process: { en: "Process", de: "Prozess" },
    results: { en: "Results", de: "Ergebnisse" },
    team: { en: "Team", de: "Team" },
    apply: { en: "Apply", de: "Bewerben" },
  },

  // ─── Hero ───
  hero: {
    eyebrow: { en: "For High-Income Expats in Germany", de: "Für Gutverdiener und Expats in Deutschland" },
    h1_line1: { en: "Turn German", de: "Verwandeln Sie" },
    h1_line2: { en: "Taxes Into", de: "Steuern in" },
    words: { en: ["Assets", "Equity", "Wealth"], de: ["Vermögen", "Eigenkapital", "Wohlstand"] },
    paragraph: {
      en: "Most expats in Germany earn well — but build too few assets. We solve that through individualized real estate strategy, tax-efficient structures, and complete execution from first analysis to signed deed.",
      de: "Die meisten Expats in Deutschland verdienen gut — bauen aber zu wenig Vermögen auf. Wir lösen das durch individualisierte Immobilienstrategie, steuereffiziente Strukturen und vollständige Umsetzung von der ersten Analyse bis zum Notartermin.",
    },
    microLine: {
      en: "Built around your income, tax bracket, liquidity, and long-term goals.",
      de: "Aufgebaut um Ihr Einkommen, Ihre Steuerklasse, Liquidität und langfristige Ziele.",
    },
    ctaPrimary: { en: "Book Strategy Call", de: "Strategiegespräch buchen" },
    ctaSecondary: { en: "See My Tax Potential", de: "Mein Steuerpotenzial sehen" },
    scrollToExplore: { en: "Scroll to explore", de: "Weiter scrollen" },
    stat1Title: { en: "Personalized Strategy", de: "Individuelle Strategie" },
    stat1Label: { en: "Income, tax bracket, liquidity, and goals", de: "Einkommen, Steuerklasse, Liquidität und Ziele" },
    stat2Title: { en: "Full Execution", de: "Komplette Umsetzung" },
    stat2Label: { en: "From first analysis to signed deed", de: "Von der ersten Analyse bis zum Notartermin" },
    stat3Title: { en: "New-Build First Logic", de: "Neubau-Erstlogik" },
    stat3Label: { en: "QNG / KfW / tax-efficient structures", de: "QNG / KfW / steuereffiziente Strukturen" },
  },

  // ─── Trust Strip ───
  trust: {
    householdsAdvised: { en: "Households Advised", de: "Beratene Haushalte" },
    avgAnnualBenefit: { en: "Avg. Annual Benefit", de: "Durchschn. Jahresvorteil" },
    bankPartners: { en: "Bank Partners", de: "Bankpartner" },
    berlinVacancy: { en: "Berlin Vacancy", de: "Berliner Leerstand" },
    yearsExperience: { en: "Years Experience", de: "Jahre Erfahrung" },
  },

  // ─── Service Pillars ───
  pillars: {
    eyebrow: { en: "Strategic Decision System", de: "Strategisches Entscheidungssystem" },
    headline1: { en: "Seven decisions.", de: "Sieben Entscheidungen." },
    headline2: { en: "One tailored strategy.", de: "Eine maßgeschneiderte Strategie." },
    intro: {
      en: "A real estate acquisition in Germany is not one decision — it is seven. Most advisors cover one or two. We connect all seven around your income, tax bracket, financing profile, and long-term goals.",
      de: "Ein Immobilienerwerb in Deutschland ist nicht eine Entscheidung — es sind sieben. Die meisten Berater decken ein oder zwei ab. Wir verbinden alle sieben um Ihr Einkommen, Ihre Steuerklasse, Ihr Finanzierungsprofil und Ihre langfristigen Ziele.",
    },
    cta: { en: "Book Strategy Call", de: "Strategiegespräch buchen" },
  },

  // ─── Bank Partners ───
  banks: {
    eyebrow: { en: "Financing Network", de: "Finanzierungsnetzwerk" },
    headline: { en: "200+ Banking and Funding Partners", de: "200+ Bank- und Finanzierungspartner" },
    description: {
      en: "We structure financing across a broad lender network to find the right fit for the client, the asset, and the strategy.",
      de: "Wir strukturieren Finanzierungen über ein breites Netzwerk, um die passende Lösung für den Kunden, das Objekt und die Strategie zu finden.",
    },
  },

  // ─── Homepage Calculator Teaser ───
  calcTeaser: {
    eyebrow: { en: "Tax-to-Asset Strategy Calculator", de: "Steuer-zu-Vermögen Strategierechner" },
    description: {
      en: "See your estimated 2026 tax burden — and what one IRE-style investment could change.",
      de: "Sehen Sie Ihre geschätzte Steuerlast 2026 — und was eine IRE-Investition verändern könnte.",
    },
    headline1: { en: "What does the state", de: "Was nimmt der Staat" },
    headline2: { en: "take from you?", de: "Ihnen weg?" },
    incomeLabel: { en: "Annual gross income", de: "Jährliches Bruttoeinkommen" },
    cta: { en: "Get Full Strategy Analysis", de: "Zur vollständigen Strategieanalyse" },
    taxBurdenLabel: { en: "Est. 2026 Tax Burden", de: "Geschätzte Steuerlast 2026" },
    recoveryLabel: { en: "Potential Year-One Recovery", de: "Potenzielle Erstjahreserholung" },
    ratio: { en: "ratio", de: "Quote" },
    disclaimer: {
      en: "Typical scenario. Official 2026 German tax logic. IRE strategy interpretation is illustrative.",
      de: "Typisches Szenario. Offizielle deutsche Steuerlogik 2026. IRE-Strategieinterpretation ist illustrativ.",
    },
  },

  // ─── Process Timeline ───
  process: {
    eyebrow: { en: "The Process", de: "Der Prozess" },
    headline1: { en: "Seven steps from first fit", de: "Sieben Schritte vom ersten Fit" },
    headline2: { en: "to full execution", de: "bis zur vollständigen Umsetzung" },
    intro: {
      en: "Not a listing funnel. A guided process from qualification and strategy to acquisition and management.",
      de: "Kein Makler-Funnel. Ein geführter Prozess von der Qualifikation und Strategie bis zum Erwerb und Management.",
    },
    cta: { en: "Start with a Strategic Fit Call", de: "Mit einem Strategiegespräch starten" },
    step: { en: "Step", de: "Schritt" },
    of: { en: "of", de: "von" },
    duration: { en: "Duration:", de: "Dauer:" },
    steps: [
      { title: { en: "Strategic Fit Call", de: "Strategisches Erstgespräch" }, duration: { en: "30 min", de: "30 Min." }, description: { en: "We assess whether a structured real estate strategy actually fits your current position — and tell you honestly if it does not.", de: "Wir prüfen, ob eine strukturierte Immobilienstrategie tatsächlich zu Ihrer aktuellen Situation passt — und sagen Ihnen ehrlich, wenn nicht." } },
      { title: { en: "Strategy Session", de: "Strategiesitzung" }, duration: { en: "60 min", de: "60 Min." }, description: { en: "We model 2–3 realistic structures around your tax bracket, capital profile, and goals — so the right first move becomes clear.", de: "Wir modellieren 2–3 realistische Strukturen um Ihre Steuerklasse, Ihr Kapitalprofil und Ihre Ziele — damit der richtige erste Schritt klar wird." } },
      { title: { en: "Property Shortlist", de: "Objektauswahl" }, duration: { en: "1-2 weeks", de: "1-2 Wochen" }, description: { en: "You receive a tightly filtered shortlist of pre-vetted opportunities aligned with your strategy — not generic listings.", de: "Sie erhalten eine eng gefilterte Auswahl vorgeprüfter Objekte, die zu Ihrer Strategie passen — keine generischen Angebote." } },
      { title: { en: "Due Diligence", de: "Due Diligence" }, duration: { en: "2-3 weeks", de: "2-3 Wochen" }, description: { en: "Location, rental logic, legal structure, and asset quality are reviewed as one coordinated investment case.", de: "Lage, Mietlogik, Rechtsstruktur und Objektqualität werden als ein koordinierter Investitionsfall geprüft." } },
      { title: { en: "Financing", de: "Finanzierung" }, duration: { en: "2-4 weeks", de: "2-4 Wochen" }, description: { en: "We structure financing around the asset and your profile — not just around approval.", de: "Wir strukturieren die Finanzierung um das Objekt und Ihr Profil — nicht nur um eine Genehmigung." } },
      { title: { en: "Notary & Purchase", de: "Notar & Kauf" }, duration: { en: "4-6 weeks", de: "4-6 Wochen" }, description: { en: "Contracts, translation, notary coordination, and closing are managed end-to-end. You sign, we execute.", de: "Verträge, Übersetzung, Notarkoordination und Abschluss werden komplett gesteuert. Sie unterschreiben, wir setzen um." } },
      { title: { en: "Management", de: "Verwaltung" }, duration: { en: "Ongoing", de: "Fortlaufend" }, description: { en: "Tenanting, rent collection, maintenance, and reporting — so ownership stays passive and scalable.", de: "Vermietung, Mieteinzug, Instandhaltung und Reporting — damit Eigentum passiv und skalierbar bleibt." } },
    ],
  },

  // ─── Case Studies ───
  cases: {
    eyebrow: { en: "Client Results", de: "Kundenergebnisse" },
    bridge: {
      en: "The process above is not theoretical. These are real outcomes produced by the same strategic framework.",
      de: "Der obige Prozess ist nicht theoretisch. Dies sind echte Ergebnisse, die durch dasselbe strategische Framework erzielt wurden.",
    },
    headline1: { en: "Real outcomes.", de: "Echte Ergebnisse." },
    headline2: { en: "Real names.", de: "Echte Namen." },
    viewAll: { en: "View All Results", de: "Alle Ergebnisse ansehen" },
    findFit: { en: "Find Your Strategic Fit", de: "Ihren strategischen Fit finden" },
  },

  // ─── Team ───
  team: {
    eyebrow: { en: "Leadership", de: "Führung" },
    headline1: { en: "The core functions", de: "Die Kernfunktionen" },
    headline2: { en: "behind IRE", de: "hinter IRE" },
    intro: {
      en: "IRE is intentionally built around a small number of high-leverage leadership functions — combining strategy, investment analysis, execution, and client support.",
      de: "IRE ist bewusst um eine kleine Anzahl wirkungsvoller Führungsfunktionen aufgebaut — die Strategie, Investitionsanalyse, Umsetzung und Kundenbetreuung verbinden.",
    },
    langLine: {
      en: "Client communication available in German, English, and Russian.",
      de: "Kundenkommunikation verfügbar auf Deutsch, Englisch und Russisch.",
    },
    supportLine: {
      en: "Supported by a focused network of project, financing, and execution partners — without building a bloated internal structure.",
      de: "Unterstützt durch ein fokussiertes Netzwerk von Projekt-, Finanzierungs- und Umsetzungspartnern — ohne eine aufgeblähte interne Struktur aufzubauen.",
    },
  },

  // ─── FAQ ───
  faq: {
    eyebrow: { en: "Frequently Asked", de: "Häufig gestellte" },
    headline1: { en: "Questions?", de: "Fragen?" },
    headline2: { en: "Straight answers.", de: "Klare Antworten." },
  },

  // ─── Consultation Form ───
  form: {
    eyebrow: { en: "Book Your Strategy Call", de: "Strategiegespräch buchen" },
    headline1: { en: "Stop earning.", de: "Hören Sie auf zu verdienen." },
    headline2: { en: "Start owning.", de: "Fangen Sie an zu besitzen." },
    intro: {
      en: "This isn't a sales call. It's a 30-minute mutual assessment. We evaluate fit in both directions — and tell you honestly whether this model is right for you.",
      de: "Das ist kein Verkaufsgespräch. Es ist eine 30-minütige gegenseitige Bewertung. Wir prüfen die Passung in beide Richtungen — und sagen Ihnen ehrlich, ob dieses Modell für Sie geeignet ist.",
    },
    whatsNext: { en: "What happens next", de: "Was passiert als Nächstes" },
    step1: { en: "We assess your income profile and tax situation", de: "Wir bewerten Ihr Einkommensprofil und Ihre Steuersituation" },
    step2: { en: "Model 2-3 investment scenarios with real numbers", de: "Modellierung von 2-3 Investitionsszenarien mit echten Zahlen" },
    step3: { en: "Give honest feedback on timing and fit", de: "Ehrliches Feedback zu Timing und Passung" },
    directContact: { en: "Prefer to reach out directly?", de: "Lieber direkt Kontakt aufnehmen?" },
    formTitle: { en: "Application Form", de: "Bewerbungsformular" },
    formSubtitle: { en: "Complete the form below and we'll be in touch within 24 hours.", de: "Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden." },
    firstName: { en: "First Name", de: "Vorname" },
    phone: { en: "Phone", de: "Telefon" },
    email: { en: "Email", de: "E-Mail" },
    income: { en: "Gross Annual Income", de: "Bruttojahreseinkommen" },
    equity: { en: "Available Equity", de: "Verfügbares Eigenkapital" },
    timeline: { en: "Investment Timeline", de: "Investitionszeitraum" },
    submit: { en: "Submit Application", de: "Bewerbung absenden" },
    submitting: { en: "Submitting...", de: "Wird gesendet..." },
    noCommitment: { en: "No commitment required. We respond within 24 hours.", de: "Keine Verpflichtung. Wir antworten innerhalb von 24 Stunden." },
    successTitle: { en: "Application Received", de: "Bewerbung eingegangen" },
    successMsg: {
      en: "Thank you for your interest. We'll review your application and be in touch within 24 hours. Expect a call from your dedicated strategy advisor.",
      de: "Vielen Dank für Ihr Interesse. Wir prüfen Ihre Bewerbung und melden uns innerhalb von 24 Stunden. Erwarten Sie einen Anruf von Ihrem persönlichen Strategieberater.",
    },
  },

  // ─── Footer ───
  footer: {
    description: {
      en: "Strategic real estate investment for high-income expats in Germany. Turn taxes into long-term assets.",
      de: "Strategische Immobilieninvestition für Gutverdiener und Expats in Deutschland. Verwandeln Sie Steuern in langfristige Vermögenswerte.",
    },
    navigation: { en: "Navigation", de: "Navigation" },
    contact: { en: "Contact", de: "Kontakt" },
    bookCall: { en: "Book Strategy Call", de: "Strategiegespräch buchen" },
    rights: { en: "All rights reserved.", de: "Alle Rechte vorbehalten." },
  },

  // ─── Cookie Consent ───
  cookie: {
    title: { en: "Privacy", de: "Datenschutz" },
    description: {
      en: "We use cookies to analyze site usage and improve your experience. Some cookies are essential, others help us understand how you interact with our content.",
      de: "Wir verwenden Cookies, um die Nutzung der Website zu analysieren und Ihr Erlebnis zu verbessern. Einige Cookies sind notwendig, andere helfen uns zu verstehen, wie Sie mit unseren Inhalten interagieren.",
    },
    acceptAll: { en: "Accept All", de: "Alle akzeptieren" },
    essentialOnly: { en: "Essential Only", de: "Nur notwendige" },
    details: { en: "Cookie details", de: "Cookie-Details" },
    hideDetails: { en: "Hide details", de: "Details ausblenden" },
    essential: { en: "Essential cookies", de: "Notwendige Cookies" },
    alwaysActive: { en: "Always active", de: "Immer aktiv" },
    essentialDesc: { en: "Required for site functionality. Cannot be disabled.", de: "Für die Funktionalität der Website erforderlich. Kann nicht deaktiviert werden." },
    analytics: { en: "Analytics & Marketing", de: "Analyse & Marketing" },
    optional: { en: "Optional", de: "Optional" },
    analyticsDesc: {
      en: "Meta Pixel, PostHog. Used to measure ad performance and improve our services. Data is processed in accordance with DSGVO.",
      de: "Meta Pixel, PostHog. Zur Messung der Anzeigenleistung und Verbesserung unserer Dienste. Daten werden gemäß DSGVO verarbeitet.",
    },
  },

  // ─── Qualification Gate ───
  gate: {
    eyebrow: { en: "Qualification", de: "Qualifikation" },
    headline1: { en: "Do you qualify?", de: "Qualifizieren Sie sich?" },
    ctaPrimary: { en: "Book Strategy Call", de: "Strategiegespräch buchen" },
    ctaSecondary: { en: "See My Tax Potential", de: "Mein Steuerpotenzial sehen" },
  },
};

export default t;
